// extracted by mini-css-extract-plugin
export default {"actions":"actions-module___actions___db50db23","submitCancelButtons":"actions-module___submitCancelButtons___f1f3df19"};